<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import changesInShareholding from './components/changesInShareholding.vue'
import transferOfInventoryAndAbnormalMovements from './components/transferOfInventoryAndAbnormalMovements.vue'

definePage({
  name: 'fluctuation',
  meta: {
    title: '经纪商异动',
  },
})
const refsList = useTemplateRef('refsList') as any
const refsPageLayout = useTemplateRef('refsPageLayout')
const refTabConten = useTemplateRef('refTabConten')
const { height: tabContenHeight } = useElementSize(refTabConten, undefined, { box: 'border-box' })
const active = ref(0)

const navbarHeight = computed(() => {
  return `${refsPageLayout.value?.navbarHeight || 0}px`
})

const tabsList = ref([
  {
    name: '持股异动',
    val: 0,
  },
  {
    name: '存仓异动',
    val: 1,
  },
  {
    name: '提仓异动',
    val: 2,
  },
  {
    name: '转仓异动',
    val: 3,
  },
])

const components: any = {
  0: changesInShareholding,
  1: changesInShareholding,
  2: changesInShareholding,
  3: transferOfInventoryAndAbnormalMovements,
}

function onTabChange() {
  nextTick(() => {
    if (refsList.value) {
      refsList.value.reLoad()
    }
  })
}
</script>

<template>
  <FmPageLayout ref="refsPageLayout" navbar back class="fluctuation-page">
    <div ref="refTabConten" class="tab-conten" :style="{ top: navbarHeight }">
      <div v-if="active === 3" class="h28px flex items-center justify-between bg-[#FFEFE5] p-l-8px p-r-8px text-11px color-[#3C78FF]">
        <div>股票仓位发生异动时，可收到提醒消息</div>
        <div class="flex items-center">
          <FmIcon name="material-symbols:add-box-outline-sharp" class="m-r-2px text-12px" />
          <span>订阅提醒</span>
        </div>
      </div>
      <van-tabs v-model:active="active" line-width="9px" @change="onTabChange">
        <van-tab v-for="item in tabsList" :key="item.val" :title="item.name" />
      </van-tabs>
    </div>
    <div :style="{ height: `${tabContenHeight}px` }" />
    <component :is="components[active]" ref="refsList" />
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }
}
</style>
